// What a look's round swatch shows, in one place for the panel and for hosts' own menus: shared
// skins show their color, like paint chips; a companion's own colors and its own skins a pie of
// their main colors; moving skins a picture of their own.
export const MOVING_SWATCHES = {
  rainbow: 'conic-gradient(#ff5a5a, #ffb03b, #f7e24a, #5ad66a, #4ab3f7, #8a6af7, #f25ad0, #ff5a5a)',
  sparkle: 'radial-gradient(circle at 30% 32%, #fff 0 2px, transparent 3px), radial-gradient(circle at 68% 62%, #fff 0 1.5px, transparent 2.5px), radial-gradient(circle at 60% 24%, #fff 0 1px, transparent 2px), #c7b6f2',
  gold: 'linear-gradient(135deg, #a97d18, #f7e08a 45%, #d9a92e 62%, #a97d18)',
  enchanted: 'repeating-linear-gradient(125deg, #6B42B0 0 3px, #C58BFF 3px 6px, #8A5AD8 6px 9px)',
  diamond: 'linear-gradient(135deg, #1E9A9A, #A1FBE8 45%, #4AEDD9 62%, #1E9A9A)',
  lava: 'radial-gradient(circle at 34% 38%, #FFE680 0 2px, transparent 3px), linear-gradient(155deg, #3A160C 18%, #E04A14 42%, #FFA024 52%, #E04A14 62%, #3A160C 85%)',
  galaxy: 'radial-gradient(circle at 30% 30%, #fff 0 1.5px, transparent 2.5px), radial-gradient(circle at 70% 64%, #CFD6FF 0 1px, transparent 2px), radial-gradient(circle at 58% 42%, #B65BD6, transparent 62%), #211A55',
  aurora: 'linear-gradient(160deg, #2FD39A, #2FB8D3 40%, #6A5BE0 70%, #B05BD6)',
  matrix: 'linear-gradient(#0f6128, #d8ffe0) 28% 15% / 3px 45% no-repeat, linear-gradient(#0f6128, #6bff95) 52% 80% / 3px 50% no-repeat, linear-gradient(#0f6128, #d8ffe0) 74% 30% / 3px 35% no-repeat, #050805',
};

// A still look's swatch as a CSS background: its skin color, or a pie of its main colors.
export function stillSwatch(look) {
  if (look.skinColor) return look.skinColor;
  const top = (look.shares || []).slice(0, 4), total = top.reduce((sum, [, share]) => sum + share, 0);   // its main colors only
  if (!top.length) return 'transparent';
  let at = 0;
  return top.length === 1 ? top[0][0]
    : `conic-gradient(${top.map(([color, share]) => `${color} ${at}deg ${(at += (share / total) * 360)}deg`).join(', ')})`;
}

// Any look's swatch as a CSS background (a moving skin without a picture of its own shows its colors).
export const swatchBackground = look => MOVING_SWATCHES[look.fx] || stillSwatch(look);
